import { createResourceUserButton } from "../../Utils/utils";
import CreateButton from "./CreateButton";

const CreateUserButtons = () => (
    <CreateButton
        create={createResourceUserButton}
    />
);

export default CreateUserButtons;
